import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import withAnalyticsEvents from '@atlaskit/analytics-next/withAnalyticsEvents';
export var WithCreateAnalyticsEvent = withAnalyticsEvents()( /*#__PURE__*/function (_React$Component) {
  _inherits(WithCreateAnalyticsEvent, _React$Component);
  var _super = _createSuper(WithCreateAnalyticsEvent);
  function WithCreateAnalyticsEvent() {
    _classCallCheck(this, WithCreateAnalyticsEvent);
    return _super.apply(this, arguments);
  }
  _createClass(WithCreateAnalyticsEvent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        render = _this$props.render,
        createAnalyticsEvent = _this$props.createAnalyticsEvent;
      return render(createAnalyticsEvent);
    }
  }]);
  return WithCreateAnalyticsEvent;
}(React.Component));